import { h, resolveComponent } from 'vue'
import {createRouter, createWebHistory} from 'vue-router'
import store from '@/store/index'

import DefaultLayout from '@/layouts/DefaultLayout'
// 관리자(?companyNo) 진입 판별 — 데이터 인사이트 라우트의 부모 레이아웃을 고른다.
// URL 파싱을 두 곳에서 각자 하면 어긋나므로 api 모듈이 읽어둔 값을 그대로 쓴다.
import { is_admin_mode } from '@/api/insight/insight.js'

const registerAuth = () => (to, from, next) => {
	if (store.state.userId) {
		return next()
	}
	next('/check-email')
}

const checkEmailAuth = () => (to, from, next) => {
	if (!store.state.userId) {
		return next()
	}
	next('/register')
}

const routes = [
	{
		path: '/',
		name: 'Home',
		component: DefaultLayout,
		redirect: '/login',
		children: [
			{
				path: '/order',
				name: 'Order',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/order/list',
				children: [
					{
						"path" : "/order/list",
						"name" : "OrderList",
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataOrderClear"
						},
						"component" : ()=>import("@/views/order/OrderList.vue"),
					},
					{
						path: '/order/list/:id',
						name: 'OrderDeail',
						component: () => import('@/views/order/OrderDetail.vue'),
					},
					{
						path: '/order/return',
						name: 'OrderReturn',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataReturnClear"
						},
						component: () => import('@/views/order/OrderReturn.vue'),
					},
					{
						path: '/order/return/:id',
						name: 'OrderReturnDeail',
						component: () => import('@/views/order/OrderDetail.vue'),
					},
					{
						path: '/order/self',
						name: 'OrderSelf',
						component: () => import('@/views/order/OrderSelf.vue'),
					},
				],
			},
			{
				path: '/deal',
				name: 'Deal',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/deal/list',
				children: [
					{
						path: '/deal/list',
						name: 'DealList',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataDealClear"
						},
						component: () => import('@/views/deal/DealList.vue'),
					},
					{
						path: '/deal/list/:id',
						name: 'DealDeail',
						component: () => import('@/views/deal/DealDetail.vue'),
					},
					{
						path: '/deal/clclt/',
						name: 'DealClclt',
						component: () => import('@/views/deal/DealClclt.vue'),
					},
				],
			},
			{
				path: '/product',
				name: 'Product',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/product/list',
				children: [
					{
						path: '/product/list',
						name: 'ProductList',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataProductClear"
						},
						component: () => import('@/views/product/ProductList.vue'),
					},
					{
						path: '/product/create',
						name: 'ProductCreate',
						component: () => import('@/views/product/ProductCreate.vue'),
					},
					{
						"path": "/product/create_related",
						"name": "RelatedProduct",
						"component": ()=>import("@/views/product/RelatedProduct.vue"),
					},
					{
						"path": "/product/create_supplies",
						"name": "SuppliesProduct",
						"component": ()=>import("@/views/product/RelatedProduct.vue"),
					},
					{
						"path": "/product/list/:id",
						"name": "ProductEdit",
						"component": ()=>import("@/views/product/ProductCreate.vue"),
						// component: () => import('@/views/product/ProductEdit.vue'),
					},
					{
						"path": "/product/list/related/:id",
						"name": "RelatedProductEdit",
						"component": ()=>import("@/views/product/RelatedProduct.vue"),
					},
					{
						"path": "/product/list/supplies/:id",
						"name": "SuppliesProductEdit",
						"component": ()=>import("@/views/product/RelatedProduct.vue"),
					},
				],
			},
			{
				path: '/stock',
				name: 'Stock',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/stock/list',
				children: [
					{
						path: '/stock/list',
						name: 'StockList',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataStockClear"
						},
						component: () => import('@/views/stock/StockList.vue'),
					},
					{
						path: '/stock/list/:id',
						name: 'StockDetail',
						component: () => import('@/views/stock/StockDetail.vue'),
					},
				],
			},
			{
				path: '/store',
				name: 'Store',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/store/list',
				children: [
					{
						path: '/store/list',
						name: 'StoreList',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataStoreClear"
						},
						component: () => import('@/views/store/StoreList.vue'),
					},
					{
						path: '/store/list/:id',
						name: 'StoreDetail',
						component: () => import('@/views/store/StoreDetail.vue'),
					},
					{
						path: '/store/adjustment',
						name: 'Adjustment',
						component: () => import('@/views/store/Adjustment.vue'),
					},
					/*{	//2025.01.02 제거
						path: '/store/month_sales_ledger',
						name: 'MonthSalesLedger',
						component: () => import('@/views/store/MonthSalesLedger.vue'),
					}*/
				],
			},
			{
				path: '/chat',
				name: 'Chat',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/chat/list',
				children: [
					{
						path: '/chat/list',
						name: 'ChattingList',
						component: () => import('@/views/chat/ChattingList.vue'),
					},{
						path: '/chat/detail',
						name: 'ChattingDetail',
						component: () => import('@/views/chat/ChattingDetail.vue'),
					},
				],
			},
			/*{
				path: '/tax',
				name: 'Tax',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/tax/list',
				children: [
					{
						path: '/tax/create',
						name: 'TaxCreate',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataTaxCreateClear"
						},
						component: () => import('@/views/tax/TaxCreate.vue'),
					},
					{
						path: '/tax/send',
						name: 'TaxSend',
						"meta" : {
							"table_sort" : true,
							"clear_fn" : "searchDataTaxSendClear"
						},
						component: () => import('@/views/tax/TaxSend.vue'),
					},
				],
			},*/
			{
				path: '/event',
				name: 'Event',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/event/list',
				children: [
					{
						path: '/event/list',
						name: 'EventList',
						component: () => import('@/views/event/EventList.vue'),
					},
					{
						path: '/event/create',
						name: 'EventCreate',
						component: () => import('@/views/event/EventCreate.vue'),
					},
					{
						path: '/event/list/:id',
						name: 'EventDetail',
						component: () => import('@/views/event/EventCreate.vue'),
					},
					{
						path: '/event/marketbang',
						name: 'EventMarketbangList',
						component: () => import('@/views/event/EventMarketbangList.vue'),
					},
					{
						path: '/event/marketbang/:id',
						name: 'EventMarketbangDetail',
						component: () => import('@/views/event/EventMarketbangDetail.vue'),
					},
				],
			},
			{
				path: '/account',
				name: 'Account',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/account/channel',
				children: [
					{
						path: '/account/channel',
						name: 'accountChannel',
						component: () => import('@/views/account/AccountChannel.vue'),
					},
					{
						path: '/account/manager',
						name: 'accountManager',
						component: () => import('@/views/account/AccountManager.vue'),
					},
					{
						path: '/account/info',
						name: 'accountInfo',
						component: () => import('@/views/account/AccountInfo.vue'),
					},
				],
			},
			{
				// 파트너 가이드 — 거래 가이드라인(정적 문서) + 명함/쿠폰 생성 도구
				// 명세: MKB-PLAN/DEV-27/기획서_명함쿠폰_개발인수.md §2
				path: '/guide',
				name: 'Guide',
				component: {
					render() {
						return h(resolveComponent('router-view'))
					},
				},
				redirect: '/guide/deal',
				children: [
					{
						path: '/guide/deal',
						name: 'GuideDeal',
						component: () => import('@/views/guide/GuideDeal.vue'),
					},
					{
						path: '/guide/namecard',
						name: 'GuideNamecard',
						component: () => import('@/views/guide/GuideNamecard.vue'),
					},
				],
			},
		],
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/user/Login'),
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('@/views/user/Register'),
		beforeEnter: registerAuth(),
	},
	{
		path: '/check-email',
		name: 'CheckEmail',
		component: () => import('@/views/user/CheckEmail'),
		beforeEnter: checkEmailAuth(),
	},
	{
		path: '/change-email/:id',
		name: 'ChangePwd',
		component: () => import('@/views/user/ChangePwd'),
	},
]

// 수입사 데이터 인사이트 — 진입 경로에 따라 셸 유무가 갈린다.
// 셀러(좌측 메뉴)는 DefaultLayout(사이드바·헤더) 안의 일반 페이지이고,
// 관리자는 어드민 수입사 상세에서 같은 URL 에 ?companyNo=N 을 붙여 새 창의
// 단독 페이지로 연다(api/insight/insight.js 참고).
// URL 이 같아 라우트를 둘로 나눌 수 없으므로 붙는 위치만 진입 모드로 가른다.
const insightRoute = {
	path: '/insight',
	name: 'Insight',
	// 다른 페이지로 나갔다 돌아와도(뒤로가기 포함) 이동 전 조회 결과를 그대로 보여준다.
	// DefaultLayout 의 KeepAlive 가 이 meta 를 보고 인스턴스를 살려 둬 재조회가 없다.
	meta: { keep_alive: true },
	component: () => import('@/views/insight/Insight.vue'),
}
if (is_admin_mode) {
	// 관리자는 셸 없이 떠야 하므로 최상위에 붙인다.
	routes.push(insightRoute)
} else {
	// 셀러는 '/'(DefaultLayout) 의 자식으로 붙인다 — 다른 메뉴와 같은 레이아웃 인스턴스를
	// 써야 페이지를 오갈 때 그 안의 KeepAlive 캐시가 살아 있다.
	routes.find((route) => route.name === 'Home').children.push(insightRoute)
}

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// KeepAlive 로 살려 둔 페이지는 뒤로가기로 돌아왔을 때 화면이 이동 전 그대로라
		// 보던 자리로 되돌린다. 나머지는 지금처럼 항상 최상단.
		if (savedPosition && to.meta.keep_alive) return savedPosition
		// 외부 링크로 들어오는 입점 상담 폼(/login#inquiry)은 화면이 폼을 펼친 뒤 직접 내려간다(views/user/Login.vue onMounted).
		// 여기서 top:0 을 돌려주면 마운트 직후 시작한 그 부드러운 스크롤을 끊어 맨 위에 멈춘다(2026-11-03).
		if (to.name === 'Login' && to.hash === '#inquiry') return false
		// always scroll to top
		return { top: 0 }
	},
})

router.beforeEach((to, from)=>{
	if( !to.meta.table_sort ) return;
	if(from.path.indexOf(to.path) === -1){
		store.commit( to.meta.clear_fn );
	}
});
export default router;
